<style lang="scss" scoped>
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';
.text-vcenter {
  vertical-align: middle;
}
code {
  margin-right: 6px;
}
.font-italic {
  font-style: italic;
}
</style>

<template lang="pug">
.container.col-centered
  .row
    h2.main_title
      | License Management
      .pull-right
        button.btn.btn-primary(v-on:click.stop="handleRegister(true)" v-if="user.role === 'admin' || isIntrising")
          span.glyphicon.glyphicon-plus
          span  New
    .col-md-12.function_bar(style="display:flex; justify-content: space-between;")
      .form-group
        label.control_label(style="margin-right: 6px;") Search:
        tooltip(effect="scale" placement="bottom" content="Search by MAC or Serial Number")
          input.form-control(style="display: inline-block; width: 240px;" v-model="temporarySearchQuery" @keydown.enter="applySearchQuery" placeholder="Search...")
      .form-group
        label.control_label(style="margin-right: 6px;") Category:
        v-select(v-bind:value.sync='logFilter.category.value' v-bind:options='logFilter.category.opts')
    spinner(v-ref:spinner size="md" show="true" v-bind:text="spinnerTxt")
    div(v-if="pageLoaded")
    pagination(
      v-bind:count-of-page.sync="countOfPage"
      v-bind:curr-page.sync="currPage"
      v-bind:count-of-pagination="countOfPagination"
      v-bind:curr-pagination-sec.sync='currPaginationSec'
      v-bind:target-ary.sync='filteredLicense'
    )
    .col-md-12.main_table
      table.table.table-bordered.table-hover.table-condensed
        tr
          th #
          th MAC
          th Serial Number
          th Category
          th Features
          th Purpose
          th Created At
          th Action
        tr(v-for="($index, x) in filteredLicense  | limitBy countOfPage pageStart")
          td.text-vcenter {{ $index + 1 + pageStart }}
          td.text-vcenter.text-uppercase.monospace(style="width:200px; white-space:normal; word-break:break-word;" v-html="highlightMatches(x.mac, searchQuery)")
          td.text-vcenter(style="width:200px; white-space:normal; word-break:break-word;")
            code(v-html="highlightMatches(x.sn, searchQuery)")
          td.text-vcenter {{ logFilter.category.map[x.category] }}
          td.text-vcenter(style="margin-right: 6px; max-width:200px; white-space: normal;")
            code(style="  display: inline-block;" v-for="(k, v) in x.entry" track-by="$index" v-if="v") {{ licenseMap[k] }}
            span(v-show="!x.entry") None
          td.text-vcenter {{ x.purpose || "(empty)" }}
          td.text-vcenter {{ x.createdAt | fromNow }}
          td.text-vcenter.text-center(style="width:170px;")
            .btn-group
              button.btn.btn-default(@click.stop="handleDownload(x)" v-bind:disabled="x.license == null")
                span.glyphicon.glyphicon-cloud-download
                span.hidden-md  Download
              //- button.btn.btn-default(@click.stop="handleEdit(true, x)")
                span.glyphicon.glyphicon-pencil
              button.btn.btn-default(@click.stop="handleShowDeleteConfirm(true, x)" v-if="!isNonAdminIntrising")
                span.glyphicon.glyphicon-trash
        tr(v-if="filteredLicense.length === 0")
          td.text-vcenter(colspan="100%"): h4.text-center.text-muted No data

modal(
  title='Register License'
  v-bind:show.sync='modal.register.show'
  )
    .modal-body(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix
          .col-md-3.form-label.clearfix
            label.control_label Registry Type:
          .col-md-9.no_pad.clearfix
            radio(style="" v-bind:checked.sync="modal.register.type" value="basic") Basic License
            div.small.text-info.font-italic(style="padding-left: 24px;" v-show="modal.register.type === 'basic'")
              p
                i.glyphicon.glyphicon-info-sign(style="margin-right: 6px;")
                span One row represents one license file for the MAC and serial number (which seperated by a comma).
              p
                span For example,
                br
                span 00:00:00:00:00:01, 00000000000000001
                br
                span 00:00:00:00:00:02, 00000000000000002
                br
                span 00:00:00:00:00:03, 00000000000000003
                br
                span 00:00:00:00:00:04, 00000000000000004
                br
                span 00:00:00:00:00:05, 00000000000000005
              p
                span As result, there will be
                b  5 license files
                span  registered and can be downloaded.

            radio(v-bind:checked.sync="modal.register.type" value="packed" :disabled="isNonAdminIntrising") Packed License (Range)
            div.small.text-info.font-italic(style="padding-left: 24px;" v-show="modal.register.type === 'packed'")
              p
                i.glyphicon.glyphicon-info-sign(style="margin-right: 6px;")
                span Only one row is allowed and represent a range of MACs and serial numbers for generating a packed license which is for manufactoring usage.
              p
                span For example,
                br
                span 00:00:00:00:00:01-00:00:00:00:00:05, 00000000000000001-00000000000000005
              p
                span As result, there will be
                b 1 packed license file
                span  and
                b  5 license files
                span  registered.

            radio(v-bind:checked.sync="modal.register.type" value="packed-list" :disabled="isNonAdminIntrising") Packed License (List)
            div.small.text-info.font-italic(style="padding-left: 24px;" v-show="modal.register.type === 'packed-list'")
              p
                i.glyphicon.glyphicon-info-sign(style="margin-right: 6px;")
                span Only one row is allowed with comma-separated MACs and serial numbers for generating a single packed license file.
              p
                span For example,
                br
                span 11:22:33:44:55:66,11:22:33:33:33:33,11:11:11:11:11:11, 00000000000000000,11111111111111111,22222222222222222
              p
                span As result, there will be
                b 1 packed license file
                span  containing licenses for all specified devices.

        .form-group.col-md-12.clearfix
          .col-md-3.form-label.clearfix
            label.control_label Targets:
          .col-md-9.no_pad.clearfix
            textarea(style="width: 100%; height: 100px; padding: 6px; resize: vertical;" v-model='modal.register.data.plaintext' v-bind:class="{'bg-danger': validation.license.plaintext.invalid}")
            span.text-danger(v-show="validation.license.plaintext.invalid") {{ validation.license.plaintext.invalidMsg }}

        .form-group.col-md-12.clearfix
          .col-md-3.form-label.clearfix
            label.control_label Category:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='modal.register.options.category' v-bind:value.sync='modal.register.data.category')
        .form-group.col-md-12.clearfix
          .col-md-3.form-label.clearfix
            label.control_label Functions:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='modal.register.options.licenseEntry' multiple v-bind:value.sync='modal.register.data.licenseEntry')
            br
            span.text-danger(v-show="validation.license.licenseEntry.invalid") {{ validation.license.licenseEntry.invalidMsg }}
        .form-group.col-md-12.clearfix
          .col-md-3.form-label.clearfix
            label.control_label Purpose:
          .col-md-9.no_pad.clearfix
            input.form-control(v-model='modal.register.data.purpose')
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click.stop='handleRegister(false)')
        | Cancel
      button.btn.btn-success(@click.stop='applyRegister' v-bind:disabled="validation.license.invalid || modal.register.locked")
        span(v-show="validation.license.invalid") Invalid
        span(v-show="!validation.license.invalid") {{ modal.register.locked ? 'Processing' : 'Register' }}

modal(
  title='Confirm'
  v-bind:show.sync='modal.delete.show'
)
    .modal-body(slot='modal-body')
      h4.text-center Are you sure to delete ?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click.stop='handleShowDeleteConfirm(false, null)')
        | No
      button.btn.btn-danger(@click.stop='applyDelete')
        | Yes
</template>

<script>
// @ is an alias to /src
// import { mapState } from 'vuex'
import { getDb, getDbTime, getDownload } from '../../index.js'
import permissionsMixin from '../../mixins/permissionsMixin.js'
import searchMixin from '../../mixins/searchMixin.js'
import _ from 'lodash'
// import mixins from '@/mixins'
import { modal, radio, select, spinner, tooltip } from 'vue-strap'
import pagination from '../common/Pagination.vue'

const licenseMap = {
  '0': 'L3L', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_L3L
  '1': 'L3', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_L3
  '2': 'TTDP', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_TTDP
  '3': 'TTDP_RNAT', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_TTDP_RNAT
  '4': 'TTDP_MULTI_ECN', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_TTDP_MULTI_ECN
  '5': 'IEC62443_4_2', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_IEC62443_4_2
  '6': 'NAT', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_NAT
  '7': 'PTP', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_PTP
  '8': 'MACsec', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_MACSEC
  '9': 'L3V6', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_L3V6
  '10': 'PROFINET', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_PROFINET
  '11': 'TTDP_DYNAMIC_ECN', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_TTDP_DYNAMIC_ECN
  '12': 'STACKING', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_STACKING
  '13': 'IEC61375_2_3', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_IEC61375_2_3
  '14': 'IEC61375_2_3_LITE', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_IEC61375_2_3_LITE
  '15': 'IEC62443_4_2_SL3', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_IEC62443_4_2_SL3
  '16': 'EthernetIP', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_ETHERNET_IP
  '17': 'ModbusTCP', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_MODBUS_TCP
  '18': 'MMS', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_MMS
  '19': 'HSR_PRP', // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_HSR_PRP
  '20': 'TSN' // LTLicenseKeyTypeOptions_LT_LICENSE_KEY_TYPE_TSN
}

export default {
  name: 'emptyVue',
  mixins: [permissionsMixin, searchMixin],
  components: {
    'v-select': select,
    spinner,
    pagination,
    modal,
    radio,
    tooltip
  },
  /* firebase: {
    fbGroup: {
      source: getDbRef('group'),
      readyCallback: function () {
        this.loaded.fbGroup = true
      }
    }
  }, */
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  props: {
    name: {
      type: String,
      default: 'text'
    }
  },
  data: () => {
    return {
      /* data loading's status, true for loaded. */
      loaded: {
        // fbGroup: false
      },
      logFilter: {
        category: {
          value: 'any',
          opts: [
            { label: 'Any', value: 'any' },
            { label: 'OS2 Pro', value: 'os2_plus' },
            { label: 'OS3', value: 'router' },
            { label: 'OS4', value: 'routerx' },
            { label: 'OS5', value: 'os5' },
            { label: 'OS6', value: 'os6' }
          ],
          map: {
            any: 'Any',
            os2_plus: 'OS2 Pro',
            router: 'OS3',
            routerx: 'OS4',
            os5: 'OS5',
            os6: 'OS6'
          }
        }
      },
      temporarySearchQuery: '',
      searchQuery: '',
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,

      spinnerTxt: 'Loading...',

      license: [],
      licenseMap: licenseMap,

      modal: {
        delete: {
          show: false,
          target: null
        },
        register: {
          show: false,
          data: {},
          defaultData: {
            plaintext: '',
            category: 'router',
            licenseEntry: []
          },
          options: {
            category: [
              { label: 'OS2 Pro', value: 'os2_plus' },
              { label: 'OS3', value: 'router' },
              { label: 'OS4', value: 'routerx' },
              { label: 'OS5', value: 'os5' },
              { label: 'OS6', value: 'os6' }
            ],
            licenseEntry: _.orderBy(_.transform(licenseMap, (result, v, k) => { result.push({ label: v, value: k }) }, []), ['label'], ['asc'])
          },
          type: 'basic'
        }
      }
    }
  },
  ready () {
    this.getData()
  },
  computed: {
    /* ...mapState({
      uid: (state) => state.user.uid,
      useRole: (state) => state.user.role
    }) */
    isNonAdminIntrising () {
      return this.isIntrising && this.user.role !== 'admin'
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    filteredLicense () {
      const selectedCategory = this.logFilter.category.value
      const searchTxt = this.searchQuery.toLowerCase().replace(/:/g, '')
      const result = this.license
        .filter((x) => {
          return selectedCategory === 'any' ||
            x.category === selectedCategory
        })
        .filter((x) => {
          const normalizedMac = x.mac.toLowerCase().replace(/:/g, '')
          return searchTxt === '' ||
            normalizedMac.includes(searchTxt) ||
            x.sn.includes(searchTxt)
        })

      console.log('this.license', this.license)
      console.log('result', result)
      return _.orderBy(result, ['createdAt'], ['desc'])
    },

    validation () {
      const result = {
        license: {
          invalid: false,
          invalidMsg: '',

          plaintext: {
            invalid: false,
            invalidMsg: ''
          },
          category: {
            invalid: false,
            invalidMsg: ''
          },
          licenseEntry: {
            invalid: false,
            invalidMsg: ''
          }
        }
      }

      const rtype = this.modal.register.type
      const {
        plaintext = '',
        licenseEntry
      } = {...this.modal.register.data}

      if (!licenseEntry.length) {
        result.license.invalid = true
        result.license.licenseEntry.invalid = true
        result.license.licenseEntry.invalidMsg += 'Required '
      }

      // check plaintext
      if (plaintext.length <= 0) {
        result.license.invalid = true
        result.license.invalidMsg = 'Required'
        result.license.plaintext.invalid = true
        result.license.plaintext.invalidMsg = 'Required'
      } else {
        const macLst = []
        const snLst = []
        const targets = plaintext.split('\n')
        if (rtype === 'basic') {
          if (targets.length > 2 && this.isNonAdminIntrising) {
            result.license.invalid = true
            result.license.plaintext.invalid = true
            result.license.plaintext.invalidMsg += 'Maximum 2 licenses allowed for QA testing. '
          }
          // check each entry
          for (let tar of targets) {
            let [mac, sn] = tar.replace(/ /g, '').split(',')
            mac = this.normalizeMAC(mac, true)
            if (!/^([a-fA-F0-9]{2}){6}$/.test(mac)) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += 'Invalid MAC is found. '
            }

            if (!/^[0-9]{16,17}$/.test(sn)) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += 'Invalid SN is found. '
            }
            if (!result.license.plaintext.invalid) {
              macLst.push(mac)
              snLst.push(sn)
            }
          }
          if (!result.license.plaintext.invalid) {
            if (macLst.length != _.uniq(macLst).length) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += 'Duplicated MAC is found. '
            }
            if (snLst.length != _.uniq(snLst).length) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += 'Duplicated SN is found. '
            }
          }
        } else if (rtype === 'packed') {
          if (targets.length > 1) {
            result.license.invalid = true
            result.license.invalidMsg = 'Only one row is allowed for packed license. '
            result.license.plaintext.invalid = true
            result.license.plaintext.invalidMsg = 'Only one row is allowed for packed license. '
          } else {
            let [macRange, snRange] = plaintext.replace(/ /g, '').split(',')
            macRange = this.normalizeMAC(macRange, true)
            if (!/^([a-fA-F0-9]{2}){6}-([a-fA-F0-9]{2}){6}$/.test(macRange)) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += 'Invalid ranged-MAC is found. '
            }

            if (!/^[0-9]{16,17}-[0-9]{16,17}$/.test(snRange)) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += 'Invalid ranged-SN is found. '
            }

            if (!result.license.plaintext.invalid) {
              const [macStart, macEnd] = macRange.split('-')
              const macStartNum = parseInt(macStart, 16)
              const macEndNum = parseInt(macEnd, 16)
              if (macStartNum >= macEndNum) {
                result.license.invalid = true
                result.license.plaintext.invalid = true
                result.license.plaintext.invalidMsg += 'Invalid, ranged-MAC must be ascending from left to right. '
              }

              const [snStart, snEnd] = snRange.split('-')
              const snStartNum = BigInt(snStart)
              const snEndNum = BigInt(snEnd)
              if (snStartNum >= snEndNum) {
                result.license.invalid = true
                result.license.plaintext.invalid = true
                result.license.plaintext.invalidMsg += 'Invalid, ranged-SN must be ascending from left to right. '
              }

              if (!result.license.plaintext.invalid) {
                const macGap = macEndNum - macStartNum
                const snGap = snEndNum - snStartNum
                if (macGap != snGap) {
                  result.license.invalid = true
                  result.license.plaintext.invalid = true
                  const snGapStr = (snGap + BigInt(1)).toString()
                  result.license.plaintext.invalidMsg += `Amount mismatched, there are ${macGap + 1} MACs comparing to ${snGapStr} SN. `
                }
                for (let i = 0; i <= macGap; i++) {
                  macLst.push(this.toMacStr(macStartNum + i, true))
                }
                for (let i = 0; i <= snGap; i++) {
                  snLst.push(this.toSnStr(snStartNum + BigInt(i)))
                }
              }
            }
          }
        } else if (rtype === 'packed-list') {
          if (targets.length > 1) {
            result.license.invalid = true
            result.license.invalidMsg = 'Only one row is allowed for packed license. '
            result.license.plaintext.invalid = true
            result.license.plaintext.invalidMsg = 'Only one row is allowed for packed license. '
          } else {
            // Parse comma-separated MACs and SNs
            const parts = plaintext.replace(/ /g, '').split(',')
            if (parts.length < 2 || parts.length % 2 !== 0) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += 'Invalid format. Expected comma-separated MACs and SNs. '
            } else {
              const midPoint = parts.length / 2
              const macParts = parts.slice(0, midPoint)
              const snParts = parts.slice(midPoint)

              // Validate MACs
              for (let mac of macParts) {
                const normalizedMac = this.normalizeMAC(mac, true)
                if (!/^([a-fA-F0-9]{2}){6}$/.test(normalizedMac)) {
                  result.license.invalid = true
                  result.license.plaintext.invalid = true
                  result.license.plaintext.invalidMsg += `Invalid MAC ${mac} is found. `
                } else {
                  macLst.push(normalizedMac)
                }
              }

              // Validate SNs
              for (let sn of snParts) {
                if (!/^[0-9]{16,17}$/.test(sn)) {
                  result.license.invalid = true
                  result.license.plaintext.invalid = true
                  result.license.plaintext.invalidMsg += `Invalid SN ${sn} is found. `
                } else {
                  snLst.push(sn)
                }
              }

              // Check for duplicate MACs
              if (macLst.length !== _.uniq(macLst).length) {
                result.license.invalid = true
                result.license.plaintext.invalid = true
                result.license.plaintext.invalidMsg += 'Duplicated MAC is found. '
              }

              // Check for duplicate SNs
              if (snLst.length !== _.uniq(snLst).length) {
                result.license.invalid = true
                result.license.plaintext.invalid = true
                result.license.plaintext.invalidMsg += 'Duplicated SN is found. '
              }
            }
          }
        } else {
          result.license.invalid = true
          result.license.invalidMsg += 'Unsupported register type. '
        }

        if (!result.license.plaintext.invalid) {
          for (const x of this.license) {
            if (macLst.some(y => this.normalizeMAC(x.mac, true) === y)) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += `MAC ${x.mac} is already registered. `
            }
            if (snLst.some(y => x.sn === y)) {
              result.license.invalid = true
              result.license.plaintext.invalid = true
              result.license.plaintext.invalidMsg += `SN ${x.sn} is already registered. `
            }

            if (result.license.plaintext.invalid) { break }
          }
        }
      }

      return result
    }
  },
  methods: {
    getData (custom) {
      console.log('getData')
      this.$refs.spinner.show()
      const query = ['admin', 'vendor'].includes(this.user.role)
        ? {
          licenseRegistry: getDb().ref('licenseRegistry/lantech_lantech').orderByChild('createdAt').limitToLast(500)
        }
        : {
          licenseRegistry: getDb().ref('licenseRegistry/lantech_lantech').orderByChild('createdAt').limitToLast(500)
        }
      query.licenseRegistry.on(
        'value',
        (sn) => {
          // this.$refs.spinner.hide()
          // this.pageLoaded = true
          console.log(sn.val())
          this.license = _.transform(sn.val(), (result, val, key) => {
            const parsed = this.parseLicenseId(key)
            if (!parsed) {
              console.warn(`[license] Skip invalid license id: ${key}`)
              return
            }
            const [mac, category, sn] = parsed
            const entry = {
              key,
              mac,
              category,
              sn,
              ...val
            }
            result.push(entry)
          }, [])
          this.$refs.spinner.hide()
          // this.pmib = _.transform(sn.val(), (result, value, key) => {
          //   if (this.user.role !== 'admin' && value.status !== 'release') return
          //   result.push({
          //     '.key': key,
          //     ...value
          //   })
          // }, []).filter(x => isEu ? ['lantech_lantech', 'lantech_pandacom'].includes(x.custom) : true)
        },
        (err) => {
          console.error(err)
          query.licenseRegistry.off()
        }
      )
    },

    parseLicenseId (licId) {
      // Get all known categories except the pseudo option 'any', and sort by length desc
      const knownCategories = Object.keys(this.logFilter.category.map)
        .filter(x => x !== 'any')
        .sort((a, b) => b.length - a.length)

      // Find the longest category token that exists in the licId (bounded by underscores)
      let foundCategory = null
      let categoryStartIndex = -1

      for (const category of knownCategories) {
        const token = '_' + category + '_'
        const idx = licId.indexOf(token)
        if (idx !== -1) {
          foundCategory = category
          categoryStartIndex = idx + 1 // Skip the leading underscore
          break
        }
      }

      if (!foundCategory) {
        console.error(`[license] Unknown category in licId: ${licId}. Known categories: ${knownCategories.join(', ')}`)
        return null
      }

      // Extract MAC (everything before the category)
      const mac = licId.substring(0, categoryStartIndex - 1)

      // Extract SN (everything after the category)
      const snStartIndex = categoryStartIndex + foundCategory.length + 1 // +1 for the underscore after category
      const sn = licId.substring(snStartIndex)

      return [mac, foundCategory, sn]
    },
    handleRegister (show) {
      this.modal.register.show = show
      this.modal.register.type = 'basic'
      this.modal.register.data = {
        ...(this.modal.register.defaultData),
        licenseEntry: [] // if no explicit set up, the binding to the defaultData maybe fixed after closing this modal
      }
    },
    async applyRegister () {
      this.modal.register.locked = true
      const result = {}
      const rtype = this.modal.register.type
      const { purpose, plaintext, category, licenseEntry } = this.modal.register.data
      const newPurpose = _.escape(purpose)
      const createdAt = getDbTime()
      const entry = _.transform(licenseEntry, (result, val, key) => result[val] = true, {})
      const targets = plaintext.replace(/ /g, '').split('\n')
      if (rtype === 'basic') {
        for (let tar of targets) {
          let [mac, sn] = tar.replace(/ /g, '').split(',')
          mac = this.normalizeMAC(mac)
          result[`${mac}_${category}_${sn}`] = {
            type: 'basic',
            createdAt,
            createdBy: this.user.email,
            entry,
            purpose: newPurpose
          }
        }
        await getDb().ref('licenseRegistry/lantech_lantech').update(result).catch(err => {
          console.error(err)
        })
      } else if (rtype === 'packed') {
        let [oriMacRange, snRange] = plaintext.replace(/ /g, '').split(',')
        const macRange = this.normalizeMAC(oriMacRange, true)
        const [macStart, macEnd] = macRange.split('-')
        const macStartNum = parseInt(macStart, 16)
        const macEndNum = parseInt(macEnd, 16)
        const macGap = macEndNum - macStartNum // after validation, it must be the same as snGap

        const [snStart, snEnd] = snRange.split('-')
        const snStartNum = parseInt(snStart, 10)
        // const snEndNum = parseInt(snEnd, 10)
        // const snGap = snEndNum - snStartNum

        // packed license
        result[`${oriMacRange}_${category}_${snRange}`] = {
          type: 'packed',
          createdAt,
          createdBy: this.user.email,
          entry,
          purpose: newPurpose
        }

        // // also save each basic license
        // for (let i = 0; i <= macGap; i++) {
        //   const mac = this.toMacStr(macStartNum + i)
        //   const sn = this.toSnStr(snStartNum + i)
        //   result[`${mac}_${category}_${sn}`] = {
        //     type: 'basic',
        //     createdAt,
        //     createdBy: this.user.email,
        //     entry,
        //     purpose: newPurpose
        //   }
        // }

        await getDb().ref('licenseRegistry/lantech_lantech').update(result).catch(err => {
          console.error(err)
        })
      } else if (rtype === 'packed-list') {
        // Handle packed-list format with comma-separated MACs and SNs
        const parts = plaintext.replace(/ /g, '').split(',')
        const midPoint = parts.length / 2
        const macParts = parts.slice(0, midPoint)
        const snParts = parts.slice(midPoint)

        // Create a single packed license entry with comma-separated values
        const macList = macParts.join(',')
        const snList = snParts.join(',')

        result[`${macList}_${category}_${snList}`] = {
          type: 'packed-list',
          createdAt,
          createdBy: this.user.email,
          entry,
          purpose: newPurpose
        }

        await getDb().ref('licenseRegistry/lantech_lantech').update(result).catch(err => {
          console.error(err)
        })
      }
      this.modal.register.locked = false
      this.handleRegister(false)
    },

    handleEdit (show, x) {

    },

    async handleDownload (x) {
      const url = await getDownload(x.license.licenseStr)

      const fileType = 'text/plain'
      var blob = new Blob([x.license.licenseStr], { type: fileType })
      var a = document.createElement('a')

      // form filename
      a.download = [
        x.mac.replace(/:/g, ''),
        x.sn,
        this.logFilter.category.map[x.category],
        // (x.entry || []).map((y, i) => licenseMap[i] || '').join('_')
        _.transform(x.entry, (result, k, v) => { if (v) {
          result.push(licenseMap[k])
        } }, []).join('_')
      ].filter(x => x !== '').join('_') + '.LCNS'

      // a.href = URL.createObjectURL(blob)
      a.href = url
      a.dataset.downloadurl = [fileType, a.download, a.href].join(':')
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      setTimeout(function () { URL.revokeObjectURL(a.href) }, 1500)

      // var xhr = new XMLHttpRequest();
      // xhr.responseType = 'blob';
      // xhr.onload = (event) => {
      //   var blob = xhr.response;
      // };
      // xhr.open('GET', url);
      // xhr.setRequestHeader('Access-Control-Allow-Headers', '*')
      // xhr.send();
    },

    handleShowDeleteConfirm (show, target) {
      this.modal.delete.show = show
      this.modal.delete.target = target
    },
    async applyDelete() {
      // console.log(this.modal.delete.target.key)
      await getDb().ref('licenseRegistry/lantech_lantech').child(this.modal.delete.target.key).set(null).catch(err => {
        console.error(err)
      })
      this.handleShowDeleteConfirm(false, null)
    },
    normalizeMAC(mac, noSeparator = false) {
      return noSeparator ? mac.toLowerCase().replace(/:/g, '') : mac.toLowerCase()
    },
    toMacStr(decimalN, noSeparator = false) {
      const nStr = decimalN.toString(16)
      const mStr = _.repeat('0', 12 - nStr.length) + nStr
      return noSeparator ? mStr : (mStr.match(/[0-9a-fA-F]{2}/g) || []).join(':')
    },
    toSnStr(decimalN) {
      const nStr = decimalN.toString()
      const mStr = _.repeat('0', 17 - nStr.length) + nStr
      return mStr
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
        console.log(nv)
      }
    },
    searchQuery () {
      this.currPage = 1
      this.currPaginationSec = 1
    },
    'user.custom' (curr, prev) {
      if (curr != null) {
        // console.log('getData')
        // this.getData(curr)
      }
    },
    'modal.register.type' (curr, prev) {
      if (curr != null) {
        this.modal.register.data.plaintext = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// License.vue?4d2240fc